interface HeaderBrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const dimensions = {
  sm: 'h-9 w-[164px]',
  md: 'h-11 w-[200px]',
  lg: 'h-16 w-[290px]',
} as const;

/** Supplied Yeastarify artwork, with a white-lettered variant for dark headers. */
export function HeaderBrandLogo({
  size = 'md',
  className = '',
}: HeaderBrandLogoProps) {
  return (
    <div
      className={`relative shrink-0 overflow-hidden ${dimensions[size]} ${className}`}
      aria-label="Yeastarify"
    >
      <img
        src="/branding/yeastarify-logo-light.png"
        alt="Yeastarify"
        className="h-full w-full object-contain object-left dark:hidden"
      />
      <img
        src="/branding/yeastarify-logo-dark.png"
        alt="Yeastarify"
        className="hidden h-full w-full object-cover object-center mix-blend-screen dark:block"
      />
    </div>
  );
}
